<template>
  <ElForm
    ref="contactInfo"
    :model="userModel"
    :rules="rules"
    label-position="top"
    @submit.native.prevent="updateContactInfo"
  >
    <ElFormItem :label="$t('POSTAL_CODE')" prop="postal_code">
      <ElInput v-model="userModel.postal_code" name="postal_code" />

      <div v-if="errors.postal_code" class="text-alert text-small">
        {{ errors.postal_code[0] }}
      </div>
    </ElFormItem>

    <ElFormItem
      v-if="userModel.country === 'IR'"
      :label="$t('PROVINCE')"
      prop="province"
      required
    >
      <AlternativeSelect
        v-model="userModel.province"
        name="province"
        key-prop="id"
        label-prop="title"
        value-prop="slug"
        :items="provinces"
        :placeholder="$t('CHOOSE')"
      />
    </ElFormItem>

    <ElFormItem :label="$t('CITY')" prop="city">
      <ElInput v-model="userModel.city" name="city" />

      <div v-if="errors.city" class="text-alert text-small">
        {{ errors.city[0] }}
      </div>
    </ElFormItem>

    <ElFormItem :label="$t('ADDRESS')" prop="address">
      <ElInput
        v-model="userModel.address"
        :autosize="{ minRows: 2, maxRows: 4 }"
        name="address"
        type="textarea"
      />
    </ElFormItem>

    <ElButton
      type="primary"
      native-type="submit"
      size="large"
      :loading="contactInfoLoading"
    >
      {{ $t('SAVE') }}
    </ElButton>

    <ElButton type="text" @click.native="$emit('cancel-edit')">
      {{ $t('CANCEL') }}
    </ElButton>
  </ElForm>
</template>

<script>
import { Publishers } from '@/api/api';
import AlternativeSelect from '@@/common/AlternativeSelect';
import form from '@/mixins/form';
import lang from '@/mixins/lang';
import provinces from '@/utils/provinces';
import { nonEmptyProps } from '@/utils/object';
import requiredWithMessage from '@/utils/validation-rules/required';

export default {
  name: 'ContactInfoForm',

  components: {
    AlternativeSelect,
  },

  mixins: [form, lang],

  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      userModel: { ...this.userData },
      contactInfoLoading: false,
      errors: {},
    };
  },

  computed: {
    provinces() {
      if (this.lang === 'fa') return provinces;
      return provinces.map(p => ({ ...p, title: p.slug }));
    },

    hasEditPermission() {
      return this.$auth.check(['publisher', 'changeFinanceInfo']);
    },

    rules() {
      return {
        address: requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
        postal_code: requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
        city: requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
      };
    },

    contactInfo() {
      const { address, postal_code, province, city } = this.userModel;
      return nonEmptyProps({
        address,
        postal_code,
        city,
        province,
      });
    },
  },

  methods: {
    updateContactInfo() {
      if (!this.hasEditPermission || !this.isValid('contactInfo')) {
        return false;
      }

      this.contactInfoLoading = true;
      this.errors = {};
      return Publishers.updateContact({}, this.contactInfo)
        .then(({ body: { message, errors = {} } }) => {
          this.$message.success(message);
          this.errors = errors;
          this.$emit('data-updated', this.contactInfo);
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }

          this.errors = errors;
        })
        .finally(() => {
          this.contactInfoLoading = false;
        });
    },
  },
};
</script>
